import { call, fork, put, takeLatest } from 'redux-saga/effects';

import { FETCH_FLEETBACK_PACK_REQUEST } from 'constants/ActionTypes';

import { fetchFleetbackPackSuccess, fetchFleetbackPackFailure } from '../actions/packActions';
import PackService from '../services/api/PackService';

function* fetchFleetbackPack() {
  try {
    const response = yield call(PackService.getFleetbackPacks);
    yield put(fetchFleetbackPackSuccess(response.data));
  } catch (error) {
    yield put(fetchFleetbackPackFailure(error));
  }
}

function* fetchFleetbackPackWatcher() {
  yield takeLatest(FETCH_FLEETBACK_PACK_REQUEST, fetchFleetbackPack);
}

const packSagas = [fork(fetchFleetbackPackWatcher)];

export default packSagas;
